import React from 'react';
import classNames from 'classnames';
import moment from 'moment';
import { ISODayToStringDay } from 'utils/date-utils';
import styles from './styles.module.scss';

const OptionChoiceCard = ({ choice, selected, onSelect }) => {
  if (choice.schedule) {
    const startDate = moment.utc(choice.schedule.start_date);
    const startTime = moment.utc(
      `${choice.schedule.start_date} ${choice.schedule.start_time}`,
    );
    const endDate = moment.utc(choice.schedule.end_date);
    const endTime = moment.utc(
      `${choice.schedule.start_date} ${choice.schedule.end_time}`,
    );

    return (
      <div
        className={classNames({
          [styles.optionChoiceCard]: true,
          [styles.selected]: selected,
        })}
      >
        <h2>{choice.name}</h2>
        <h3>Starts {startDate.format('ddd MMM D')}</h3>
        <h5>Every {choice.schedule.days.map(ISODayToStringDay).join(', ')}</h5>
        <h5>
          {startTime.format('h:mm a')} to {endTime.format('h:mm a')}
        </h5>
        <h5>Until {endDate.format('ddd MMM D')}</h5>
        {choice.quantity_remaining && (
          <h5 className="text-red font-heavy">
            Only {choice.quantity_remaining} left!
          </h5>
        )}
        {onSelect && (
          <button
            type="button"
            onClick={onSelect}
            className={styles.selectButton}
          >
            {selected ? 'Selected' : 'Select'}
          </button>
        )}
      </div>
    );
  }
  return (
    <div
      className={classNames({
        [styles.optionChoiceCard]: true,
        [styles.selected]: selected,
      })}
    >
      <h3>{choice.name}</h3>
      {onSelect && (
        <button
          type="button"
          onClick={onSelect}
          className={styles.selectButton}
        >
          {selected ? 'Selected' : 'Select'}
        </button>
      )}
    </div>
  );
};

export default OptionChoiceCard;
